export default {
    props: {
        defaultCloseHandler: {
            type: Function,
            required: true
        }
    }
};
